<div class="settings-page">

  <div class="page-header">

    <div>

      <div class="breadcrumb">
        HR Management / Settings
      </div>

      <h1>
        Settings
      </h1>

      <p>
        Manage application preferences and company configuration.
      </p>

    </div>

  </div>


  <mat-card class="settings-card">

    <div class="settings-content">

      <h2>
        <mat-icon>business</mat-icon>
        Company Information
      </h2>

      <div class="form-grid">

        <mat-form-field appearance="outline" class="full-width">

          <mat-label>
            Company Name
          </mat-label>

          <input
            matInput
            formControlName="companyName"
            required>

        </mat-form-field>

        <mat-form-field appearance="outline">

          <mat-label>
            Email Address
          </mat-label>

          <input
            matInput
            formControlName="companyEmail"
            type="email"
            required>

        </mat-form-field>

        <mat-form-field appearance="outline">

          <mat-label>
            Phone Number
          </mat-label>

          <input
            matInput
            formControlName="companyPhone">

        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">

          <mat-label>
            Address
          </mat-label>

          <input
            matInput
            formControlName="companyAddress">

        </mat-form-field>

      </div>

    </div>

  </mat-card>


  <mat-card class="settings-card">

    <div class="settings-content">

      <h2>
        <mat-icon>language</mat-icon>
        Preferences
      </h2>

      <div class="form-grid">

        <mat-form-field appearance="outline">

          <mat-label>
            Currency
          </mat-label>

          <mat-select formControlName="currency">

            <mat-option value="USD">
              USD ($)
            </mat-option>

            <mat-option value="EUR">
              EUR (€)
            </mat-option>

            <mat-option value="GBP">
              GBP (£)
            </mat-option>

            <mat-option value="PKR">
              PKR (₨)
            </mat-option>

          </mat-select>

        </mat-form-field>

        <mat-form-field appearance="outline">

          <mat-label>
            Timezone
          </mat-label>

          <mat-select formControlName="timezone">

            <mat-option value="UTC-5">
              Eastern Time (UTC-5)
            </mat-option>

            <mat-option value="UTC+0">
              GMT (UTC+0)
            </mat-option>

            <mat-option value="UTC+5">
              Pakistan Time (UTC+5)
            </mat-option>

          </mat-select>

        </mat-form-field>

        <mat-form-field appearance="outline">

          <mat-label>
            Language
          </mat-label>

          <mat-select formControlName="language">

            <mat-option value="English">
              English
            </mat-option>

            <mat-option value="Spanish">
              Spanish
            </mat-option>

            <mat-option value="French">
              French
            </mat-option>

            <mat-option value="Arabic">
              Arabic
            </mat-option>

          </mat-select>

        </mat-form-field>

      </div>

    </div>

  </mat-card>


  <mat-card class="settings-card">

    <div class="settings-content">

      <h2>
        <mat-icon>tune</mat-icon>
        Application Settings
      </h2>

      <div class="toggles-grid">

        <div class="toggle-item">

          <mat-slide-toggle
            formControlName="emailNotifications"
            color="primary">

            Email Notifications

          </mat-slide-toggle>

          <p>
            Receive email alerts for important updates.
          </p>

        </div>

        <div class="toggle-item">

          <mat-slide-toggle
            formControlName="smsNotifications"
            color="primary">

            SMS Notifications

          </mat-slide-toggle>

          <p>
            Receive SMS alerts for urgent notifications.
          </p>

        </div>

        <div class="toggle-item">

          <mat-slide-toggle
            formControlName="autoBackup"
            color="primary">

            Auto Backup

          </mat-slide-toggle>

          <p>
            Automatically backup data on a scheduled basis.
          </p>

        </div>

        <div class="toggle-item">

          <mat-slide-toggle
            formControlName="darkMode"
            color="primary">

            Dark Mode

          </mat-slide-toggle>

          <p>
            Switch the application to the dark theme. You can also cycle themes from the header.
          </p>

        </div>

      </div>

    </div>

  </mat-card>


  <div class="action-buttons">

    <button
      mat-stroked-button
      (click)="resetSettings()">

      <mat-icon>
        restart_alt
      </mat-icon>

      Reset to Default

    </button>

    <button
      mat-raised-button
      color="primary"
      (click)="saveSettings()"
      [disabled]="settingsForm.invalid || loading">

      <mat-icon>
        save
      </mat-icon>

      Save Settings

    </button>

  </div>

</div>
